import React from 'react'

interface MobileMaskProps {
  visible: boolean
  onClose: () => void
}

const MobileMask: React.FC<MobileMaskProps> = ({ visible, onClose }) => {
  if (!visible) return null

  return (
    <div
      className="mobile-mask"
      onClick={onClose}
    />
  )
}

export default MobileMask

